import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { monthOptions, yearOptions } from "../../../config";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { tableConfig, transformResponseYearsToDateToTable } from "./config";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { saveAs } from "file-saver";
import { buildExcelRequestBodyJualPartYTD } from "../configExcel";

export default class LaporanYTD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      menuName: null,
      dataTable: [],
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  loadDDL = () => {
    const currentYear = Number(moment().format("YYYY"));
    this.setState({
      year: yearOptions.find((item) => item.value === currentYear),
      menuName: "LAPORAN SERVICE 3 TAHUN TERAKHIR",
    });
  };

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO")
            .getLaporanJualPartYearToDateByCabangH23,
        setError: this.props.setError,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Jual Part YTD",
        args: {
          kodeCabang: this.props.search,
          year: this.state.year.value,
        },
      });

      if (res.ok && res.data.status === "S") {
        const rawData = res.data.data || [];

        this.setState({
          dataTable: transformResponseYearsToDateToTable(rawData),
        });
      }

      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("errors: ", error);
    }
  };

  handlePrint = async () => {
    const { month, year, dataTable } = this.state;
    this.props.triggerLoading();

    try {
      const reqBody = buildExcelRequestBodyJualPartYTD({
        year,
        dataTable
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Jual Part YTD",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      this.props.triggerLoading();
    }
  };

  render() {
    const { month, year } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={this.handleSearch}
          />
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton id="btn_print" text="CETAK" onClick={() => this.handlePrint()} />
        </FlexView>
      </React.Fragment>
    );
  }
}
